
export class ActualizarFecha{
  fechaHora : string;
  fechaHoraHasta:string;
  precio:number;
  responsable: string;
  detalle: string;
}
